import React from 'react'

import {
  Box,
  ButtonDialog,
  Grid,
  IconButton,
  makeAppStyles,
  RadioFormGroup,
  RoundedPlainTextButton,
  Typography,
} from '@percept/mui'

import { Close, Settings } from '@percept/mui/icons'

import { DashboardCard } from 'components/DashboardCard'

import { useManageThemeTypePreference, UserMFAManagement } from '@percept/app-components'

import { useCanManageMFA } from '@percept/hooks'

import { useTargetCurrency } from 'hooks'

import { currencyOptions } from 'components/CurrencySelect'


const CurrencyManagement = (): JSX.Element => {
  const [targetCurrency, setTargetCurrency] = useTargetCurrency()
  return (
    <RadioFormGroup
      name='Currency'
      value={targetCurrency}
      options={currencyOptions}
      onChange={setTargetCurrency} />
  )
}

const ThemeManagement = (): JSX.Element => {
  const [themeTypePreference, setThemeTypePreference] = useManageThemeTypePreference()
  return (
    <RadioFormGroup
      name='Theme Preference'
      value={themeTypePreference}
      onChange={setThemeTypePreference}
      options={[
        { value: 'AUTO', label: 'Automatic' },
        { value: 'LIGHT', label: 'Light' },
        { value: 'DARK', label: 'Dark' },
      ]} />
  )
}

const useStyles = makeAppStyles( theme => ({
  backdrop: {
    backgroundColor: 'rgba(0,0,0,0.35)',
  },
  titleIcon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(-1),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
}))

export const AppSettings = () => {
  const canManageMFA = useCanManageMFA()
  const classes = useStyles()
  return (
    <ButtonDialog
      ButtonComponent={RoundedPlainTextButton}
      buttonContent='Settings'
      size='small'
      startIcon={<Settings />}
      DialogProps={{
        maxWidth: 'xs',
        fullWidth: true,
        classes: {
          root: classes.backdrop,
        }
      }}>
      { ({ onClose }) => (
        <DashboardCard
          title={
            <>
              <IconButton
                className={classes.titleIcon}
                size='small'
                color='inherit'
                onClick={onClose}>
                <Close />
              </IconButton>
              Settings
            </>
          }
          color='primary'>
          <Box p={3}>
            { canManageMFA && (
              <Box mb={6}>
                <Typography className={classes.sectionTitle} variant='h5'>User</Typography>
                <Grid container justify='center'>
                  <Grid item xs='auto'>
                    <UserMFAManagement mt={0} mb={0} onClose={onClose} />
                  </Grid>
                </Grid>
              </Box>
            )}
            <Typography className={classes.sectionTitle} variant='h5'>Application</Typography>
            <Grid container justify='center' spacing={8}>
              <Grid item xs='auto'>
                <CurrencyManagement />
              </Grid>
              <Grid item xs='auto'>
                <ThemeManagement />
              </Grid>
            </Grid>
          </Box>
        </DashboardCard>
      )}
    </ButtonDialog>
  )
}
